module.exports = __webpack_public_path__ + "static/media/login-bg-1-warning.7fc9507a.png";